import React from "react"
import { Box, Text, VStack, Flex, Spinner } from "@chakra-ui/react"
import { PreClassQuestionInput } from "./PreClassQuestionInput"
import { QuestionBubble } from "./QuestionBubble"
import { usePreClassQuestions } from "./usePreClassQuestions"
import { c } from "../classroomColors"

/**
 * Student side of the pre-class Q&A (Figma: pre-class-student). An input to
 * leave questions for the teacher, with the student's own questions and their
 * answers listed below.
 */
export function PreClassStudentPanel({ courseGuid, segmentGuid, bare = false, onChanged }) {
  const { questions, loading, error, ask, remove } = usePreClassQuestions({
    courseGuid,
    segmentGuid,
  })

  const notify = (fn) => async (...args) => {
    const result = await fn(...args)
    if (typeof onChanged === "function") onChanged()
    return result
  }

  const shell = bare
    ? {}
    : {
        borderRadius: "12px",
        border: "1px solid",
        borderColor: c.borderSoft,
        background: c.surfaceSubtle,
        padding: "16px",
        mb: "20px",
      }

  return (
    <Box {...shell}>
      {!bare && (
        <Text fontSize="13px" fontWeight="600" color={c.text} mb="10px">
          Pre class questions
        </Text>
      )}

      <PreClassQuestionInput onSubmit={notify(ask)} />

      {loading ? (
        <Flex justify="center" py="14px">
          <Spinner size="sm" color={c.accent} />
        </Flex>
      ) : error ? (
        <Text fontSize="12px" color={c.textMuted} mt="12px">
          {error}
        </Text>
      ) : questions.length > 0 ? (
        <VStack align="stretch" spacing="8px" mt="12px" maxHeight="240px" overflowY="auto" pr="4px">
          {questions.map((q) => (
            <QuestionBubble key={q.guid} question={q} onDelete={notify(remove)} />
          ))}
        </VStack>
      ) : (
        <Text fontSize="11.5px" color={c.textMuted} mt="10px" fontStyle="italic">
          Questions you ask before class will show up here with your teacher's answers.
        </Text>
      )}
    </Box>
  )
}
